module.exports = require("./scripts/index.js");


//////////////////
// WEBPACK FOOTER
// ./collection-institutional-portal/src/widgets/widget-usp-product/widget/model.xml
// module id = 0
// module chunks = 165